<template>
    <span>
        <human-date v-if="value && type === 'date'" :date="parseDate(value)" />
        <template v-else>{{ renderValue }}</template>
    </span>
</template>
<script>
export default {
    name: "custom-field-value",
    props: {
        value: String,
        type: String,
    },
    computed: {
        renderValue() {
            if (!this.value) return this.t('custom_fields-not_informed');

            if (this.type === 'user') {
                return this.users.find((i) => String(i.id) === String(this.value))?.name || this.t('custom_fields-not_found');
            }

            const json = this.tryParse(this.value);
            return json && Array.isArray(json)
                ? json.map(x => x.text).join(', ')
                : this.value;
        },
        users() {
            return this.$store.state.users;
        },
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        tryParse(str) {
            try {
                return JSON.parse(str);
            } catch {
                return null;
            }
        },
        getUserName(value) {
            return (
                this.users.find((i) => String(i.id) === String(value))?.name ||
                this.t('custom_fields-not_found')
            );
        },
        parseDate(value) {
            const date = new Date(value);
            return date;
        },
    },
};
</script>
